import styled from "styled-components";
import { LightTheme } from "@/commons/constants/ThemeColor.ts";

const bgLayout: string = LightTheme.BlueBg;
export const HeaderWrapper = styled.div`
	height: auto;
	min-height: 48px;
	width: 100%;
	background-color: ${bgLayout};
	display: flex;
	align-items: center;
	justify-content: space-between;
	a {
		color: #ffffff;
		font-weight: 700;
		font-size: 16px;
		&:hover,
		&:active,
		&:focus {
			color: #ffffff;
			text-decoration: none;
		}
		&:active:hover {
			color: #ffffff;
			text-decoration: none;
		}
	}
	@media screen and (max-width: 850px) {
		.is-pc {
			display: none;
		}
		.is-mobile {
			display: flex;
		}
	}
	@media screen and (min-width: 600px) {
		.is-pc {
			display: flex;
		}
		.is-mobile {
			display: none;
		}
	}
	.hover-custom:hover {
		background: rgb(244, 244, 244);
	}
`;

export const ContentWrapper = styled.div`
	width: 50%;
	height: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 5px 0 5px 25px;
	@media screen and (max-width: 850px) {
		flex-direction: column;
		justify-content: center;
		align-items: normal;
	}
`;

export const HeaderTittle = styled.div`
	@media screen and (max-width: 850px) {
		font-size: 14px;
		white-space: nowrap;
	}

    .fui-Link {
        color: #ffffff;
        font-weight: 700;
        font-size: 16px;

        &:hover,
        &:active,
        &:focus {
            color: #ffffff;
            text-decoration: none;
        }

        &:active:hover {
            color: #ffffff;
            text-decoration: none;
        }
    }
`;
export const HeaderName = styled.div`
	color: #ffffff;
	font-weight: 500;
	font-size: 18px;
	@media screen and (max-width: 850px) {
		font-size: 12px;
		white-space: nowrap;
	}
`;

export const BtnWrapper = styled.div`
	padding-right: 25px;
	height: 100%;
	display: flex;
	align-items: center;
`;
